import { twMerge } from "tailwind-merge";

export const TableFillHeightBody = ({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge("flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden", className)}
      {...rest}
    />
  );
};
